import { createFileRoute, Outlet } from '@tanstack/react-router';
import CostCenters from '../../components/CostCenters';
import { PERMISSION_COST_CENTERS } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/system_settings/cost-centers')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_COST_CENTERS, ['read'], '/unauthorized', context);
    return { ...context };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: CostCentersLayout,
});

function CostCentersLayout() {
  return (
    <>
      <CostCenters />
      <Outlet />
    </>
  );
}
